<!-- 
Exception logs listing page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="Exception logs"
      user-guide-topic="administration-exception-logs"
    />
    <our-search-bar>
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="quickSearch"
        label="Message or ID" 
        field="search" 
        field-if-numeric="id" 
        @changed="$refs.listing.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search exception logs"
        @changed="$refs.listing.refresh()"
      />
      <our-saved-searches-menu
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="exceptionLogs" 
        @selected="$refs.listing.refresh()"
      />
      <div slot="right">
        <v-menu v-model="test" :class="{'full-width': xs }" offset-y>
          <v-btn slot="activator" :block="xs" :class="{'mr-3': !xs}" class="ml-0 mb-3">
            <v-icon class="mr-2">build</v-icon>
            Diagnostic tools
            <v-icon :class="'ml-1 expand-icon ' + (test ? 'expanded' : '')">expand_more</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="showTestErrorHandlingDialog=true">
              <v-list-tile-title>
                <v-icon class="mr-2">report_problem</v-icon>
                Error handling
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="canTestSap" @click="showSapConnectivityTestDialog=true">
              <v-list-tile-title>
                <v-icon class="mr-2">compare_arrows</v-icon>
                SAP connectivity
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="canViewAppSettings" @click="showAppSettingsDialog=true">
              <v-list-tile-title>
                <v-icon class="mr-2">perm_data_setting</v-icon>
                App settings
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu v-model="stats" :class="{'full-width': xs }" offset-y>
          <v-btn slot="activator" :block="xs" class="ml-0 mr-0 mb-3">
            <v-icon class="mr-2">bar_chart</v-icon>
            Statistics
            <v-icon :class="'ml-1 expand-icon ' + (stats ? 'expanded' : '')">expand_more</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="showErrorsOverLastWeek=true">
              <v-list-tile-title>
                <v-icon class="mr-2">bar_chart</v-icon>
                Errors over the last week
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="showExceptionCountsByMonth=true">
              <v-list-tile-title>
                <v-icon class="mr-2">timeline</v-icon>
                Exceptions counts by month
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="showExceptionCountsByLevel=true">
              <v-list-tile-title>
                <v-icon class="mr-2">donut_large</v-icon>
                Exception counts by level
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </our-search-bar>
    <exception-log-listing ref="listing" @click="openExceptionLog" />
    <errors-over-last-week-dialog v-model="showErrorsOverLastWeek" />
    <exception-counts-by-month-dialog v-model="showExceptionCountsByMonth" />
    <exception-counts-by-level-dialog v-model="showExceptionCountsByLevel" />
    <sap-connectivity-test-dialog v-model="showSapConnectivityTestDialog" />
    <test-error-handling-dialog v-model="showTestErrorHandlingDialog" />
    <app-settings-dialog v-model="showAppSettingsDialog" />
  </div>
</template>

<script>
import ExceptionLogListing from "@/components/exception-logs/ExceptionLogListing.vue";
import ErrorsOverLastWeekDialog from "@/components/exception-logs/ErrorsOverLastWeekDialog.vue";
import ExceptionCountsByMonthDialog from "@/components/exception-logs/ExceptionCountsByMonthDialog.vue";
import ExceptionCountsByLevelDialog from "@/components/exception-logs/ExceptionCountsByLevelDialog.vue";
import SapConnectivityTestDialog from "@/components/exception-logs/SapConnectivityTestDialog.vue";
import TestErrorHandlingDialog from "@/components/exception-logs/TestErrorHandlingDialog.vue";
import AppSettingsDialog from "@/components/exception-logs/AppSettingsDialog.vue";
import * as claim from "@/store/claim-types";
import * as mutation from "@/store/exception-logs/mutation-types";
import { getSearchFilters } from "@/store/exception-logs/helpers";

export default {
  name: "ExceptionLogs",
  components: {
    ExceptionLogListing,
    SapConnectivityTestDialog,
    TestErrorHandlingDialog,
    AppSettingsDialog,
    ErrorsOverLastWeekDialog,
    ExceptionCountsByMonthDialog,
    ExceptionCountsByLevelDialog
  },
  data() {
    return {
      test: false,
      stats: false,
      showErrorsOverLastWeek: false,
      showExceptionCountsByMonth: false,
      showExceptionCountsByLevel: false,
      showSapConnectivityTestDialog: false,
      showTestErrorHandlingDialog: false,
      showAppSettingsDialog: false,
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      breadcrumbs: [{ text: "Exception logs" }]
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters();
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    criteria() {
      return this.$store.state.exceptionLogs.listing.criteria;
    },
    quickSearch() {
      return this.criteria.id && !this.criteria.search ? this.criteria.id : this.criteria.search;
    },
    canTestSap() {
      return this.$store.getters.claims.includes(claim.SAP_TESTING);
    },
    canViewAppSettings() {
      return this.$store.getters.claims.includes(claim.APPLICATION_SETTINGS_VIEW);
    }
  },
  methods: {
    openExceptionLog(id) {
      this.$router.push({ path: `/exception-logs/${id}` });
    }
  }
};
</script>

<style lang="scss">
div.full-width {
  width: 100%;
}
</style>